
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaUserCircle, FaHome } from 'react-icons/fa';
import ObservacionesCatalog from './ObservacionesCatalog';

export default function ObservacionesPage() {
  const isSmall = isMobile || isTablet;

  return (
    <div className="panel-sigma-layout">
      <aside className={`panel-sigma-sidebar ${isSmall ? 'panel-sigma-sidebar-responsive' : ''}`}>
        {!isSmall && (
          <div className="panel-sigma-avatar">
            <FaUserCircle size={48} />
          </div>
        )}
        <nav className="panel-sigma-nav">
          <button title="Inicio"><FaHome /></button>
        </nav>
      </aside>

      <ObservacionesCatalog />
    </div>
  );
}
